import api from 'base/utils/api';
import type {
    IApiGetMessageList,
    IApiMarkMessageRead,
    IApiGetStationMessage,
    IMessageListData,
    IUnReadData
} from 'base/interfaces/message';
import { IConfigData } from 'base/interfaces/message';

// 获取消息列表
export async function getMessageList(params: IApiGetMessageList): Promise<IMessageListData> {
    return api.post('/web/message/center/station/content/type', {
        data: params
    })
}

// 获取未读条数
export async function getUnReadCount(): Promise<IUnReadData> {
    return api.post('/web/message/center/station/unRead')
}

// 标记消息已读
export async function markMessageRead(params: IApiMarkMessageRead): Promise<any> {
    return api.post('/web/message/center/station/markRead', {
        data: params
    })
}

// 获取消息配置 icons
export async function getStationMessage(params: IApiGetStationMessage): Promise<IConfigData> {
    return api.get('/web/featureConfig/getStationMessage', {
        params: params
    })
}

// 标记消息全部已读
export async function markMessageReadAll(): Promise<any> {
    return api.post('/web/message/center/station/markRead/all')
}
